import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18n";
import { Loader2, Disc3, Search } from "lucide-react";

export default function Albums() {
  const { t } = useI18n();
  const [albums, setAlbums] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/music/albums").then((r) => setAlbums(r.data.albums)).catch(() => setAlbums([]));
  }, []);

  const filtered = (albums || []).filter((a) =>
    a.name.toLowerCase().includes(q.toLowerCase()) || (a.artist || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-4 md:p-8 pb-6" data-testid="albums-page">
      <h1 className="font-heading text-3xl font-bold mb-4">{t("all_albums")}</h1>
      <div className="flex items-center gap-2 bg-white/5 rounded-lg px-3 max-w-sm mb-6">
        <Search className="w-4 h-4 text-zinc-500" />
        <input data-testid="albums-filter" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("filter_albums")} className="flex-1 bg-transparent py-2 text-sm focus:outline-none" />
      </div>

      {albums === null ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-zinc-500" /></div>
      ) : filtered.length === 0 ? (
        <p className="text-zinc-500 text-sm py-10 text-center">{t("no_albums")}</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {filtered.map((al) => (
            <Link key={al.id} to={`/app/album/${al.id}`} data-testid={`album-grid-${al.id}`} className="bg-white/5 hover:bg-white/10 rounded-xl p-4 transition-colors">
              {al.cover ? <img src={al.cover} alt="" className="w-full aspect-square rounded-lg object-cover" /> : <div className="w-full aspect-square rounded-lg bg-white/10 flex items-center justify-center"><Disc3 className="w-10 h-10 text-zinc-500" /></div>}
              <p className="text-sm font-semibold truncate mt-3">{al.name}</p>
              <p className="text-xs text-zinc-400 truncate">{al.artist} · {al.track_count} {t("tracks")}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
